<template>
    <div class="col-12 my-2">
    <div class="col-sm-12 search-form-title px-2">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <contract-filter
        ref="filter"
        :user="user"
        class="px-2"
        :show-only-my-contracts-option="true"
        @contract-set="setContract"
        @company-set="companySet"
      />
      <div class="row px-2">
        <div class="col-sm-3">
          <span class="span-title">{{ $t('storm_sewers.material') }}</span>
          <select
            id="material"
            v-model="material"
            class="form-select form-select-sm sm-3"
          >
            <option :value="null">
                {{ $t('road_sign.select_material') }}
            </option>
            <option
                v-for="item in getMaterialOptions()"
                :key="item.value"
                :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
        <div class="col-sm-3">
          <span class="span-title">{{ $t('storm_sewers.status') }}</span>
          <select
            id="area"
            v-model="status"
            class="form-select form-select-sm sm-3"
          >
            <option :value="-1">
              {{ $t('storm_sewers.select_status') }}
            </option>
            <option
              v-for="item in getStatusOptions()"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
          <div class="col-sm-3">
              <span class="span-title">{{ $t('storm_sewers.type_sewer_type') }}</span>
              <select
                  id="area"
                  v-model="sewerTypeId"
                  class="form-select form-select-sm sm-3"
              >
                  <option :value="-1">
                      {{ $t('storm_sewers.type_select_type') }}
                  </option>
                  <option
                      v-for="item in getSewerTypeOptions()"
                      :key="item.value"
                      :value="item.value"
                  >
                      {{ item.text }}
                  </option>
              </select>
          </div>
      </div>
      <div class="row px-2">
        <div class="col-sm-3">
          <span class="span-title">{{ $t('storm_sewers.radius_min') }}</span>
          <input
            id="searchMinRadius"
            v-model.number="minRadius"
            type="number"
            step="any"
            class="form-control form-control-sm"
          >
        </div>
        <div class="col-sm-3">
          <span class="span-title">{{ $t('storm_sewers.radius_max') }}</span>
          <input
            id="searchMaxRadius"
            v-model.number="maxRadius"
            type="number"
            step="any"
            class="form-control form-control-sm"
          >
        </div>
      </div>
      <div class="col-sm-12 button-container">
          <button type="reset" class="form-button btn btn-sm btn-danger">
              {{ $t('ins_report.clear') }}
          </button>
          <button type="submit" class="form-button btn btn-sm btn-primary">
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
  </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";

export default {
    name: 'StormSewerLineSearch',
    components: {ContractFilter},
    mixins: [stormSewersMixin],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            contract: null,
            company: null,
            material: null,
            radius: null,
            minRadius: null,
            maxRadius: null,
            status: null,
            sewerTypeId: null
        }
    },
    mounted() {
        this.status = -1
        this.sewerTypeId = -1
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if(this.material) {
                params.material = this.material
            }
            if(this.radius) {
                params.radius = this.radius
            }
            if(this.minRadius && this.minRadius > 0) {
                params.min_radius = this.minRadius
            }
            if(this.maxRadius && this.maxRadius > 0) {
                params.max_radius = this.maxRadius
            }
            if(this.status && this.status > 0) {
                params.status = this.status
            }
            if(this.sewerTypeId && this.sewerTypeId > 0) {
                params.sewer_type_id = this.sewerTypeId
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.company = null
            this.material = null
            this.minRadius = null
            this.maxRadius = null
            this.status = null
            this.sewerTypeId = null
            this.$refs.filter.resetData()
        }
    }
}
</script>
